import { render, staticRenderFns } from "./AgentWithdraw.vue?vue&type=template&id=5a320f41&scoped=true"
import script from "./AgentWithdraw.vue?vue&type=script&lang=js"
export * from "./AgentWithdraw.vue?vue&type=script&lang=js"
import style0 from "./AgentWithdraw.vue?vue&type=style&index=0&id=5a320f41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a320f41",
  null
  
)

export default component.exports